var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFBene4Cp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "uuid-f364fb3b-debc-4a07-b03c-51cebf6fa350",
    viewBox: "0 0 90.7 90.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,85.7c-22.25,0-40.35-18.1-40.35-40.35S23.1,5,45.35,5s40.35,18.1,40.35,40.35-18.1,40.35-40.35,40.35ZM45.35,9.76c-19.62,0-35.59,15.97-35.59,35.59s15.97,35.59,35.59,35.59,35.59-15.97,35.59-35.59S64.97,9.76,45.35,9.76Z",
    fill: "#4a46ab"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-0bdb50c7-e9b1-4a0f-b986-f8dd1aaa3004"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.77,29.92h-30.85c-2.43,0-4.41,1.98-4.41,4.41v15.42c0,2.43,1.98,4.41,4.41,4.41h30.85c2.43,0,4.41-1.98,4.41-4.41v-15.42c0-2.43-1.98-4.41-4.41-4.41ZM60.13,36.99l-11.02,11.02c-.86.86-2.25.86-3.12,0l-5.05-5.05-7.26,7.26c-.43.43-.99.65-1.56.65s-1.13-.22-1.56-.65c-.86-.86-.86-2.25,0-3.12l8.81-8.81c.86-.86,2.25-.86,3.12,0l5.05,5.05,9.46-9.46c.86-.86,2.25-.86,3.12,0s.86,2.25,0,3.12Z",
    fill: "#4a46ab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.18,60.77H25.52c-1.22,0-2.2-.99-2.2-2.2s.99-2.2,2.2-2.2h39.66c1.22,0,2.2.99,2.2,2.2s-.99,2.2-2.2,2.2Z",
    fill: "#4a46ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFBene4Cp);
export default __webpack_public_path__ + "static/media/F-Bene4-CP.f4c772ded60b95afd519ddc0fc6f565e.svg";
export { ForwardRef as ReactComponent };